var _path, _path2, _path3, _path4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 38,
    viewBox: "0 0 33 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.4975 0H5.55963C2.49397 0 0 2.49397 0 5.55963V28.831C0 31.8967 2.49397 34.3906 5.55963 34.3906H11.3743C12.0076 34.3906 12.5219 33.8763 12.5219 33.243C12.5219 32.6097 12.0076 32.0954 11.3743 32.0954H5.55963C3.76061 32.0954 2.29526 30.6322 2.29526 28.831V5.55963C2.29526 3.75849 3.75849 2.29526 5.55963 2.29526H26.4975C28.2965 2.29526 29.7619 3.75849 29.7619 5.55963V28.831C29.7619 30.2432 28.8618 31.4854 27.5187 31.9232C26.9151 32.1198 26.5878 32.767 26.7844 33.3705C26.981 33.9741 27.6292 34.3003 28.2317 34.1048C30.5206 33.3588 32.0582 31.2378 32.0582 28.831V5.55963C32.0571 2.49397 29.5632 0 26.4975 0Z",
    fill: "url(#paint0_linear_0_289)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6255 19.8636C16.2464 19.8636 13.4942 22.6126 13.4942 25.9928C13.4942 27.6972 14.1966 29.2391 15.324 30.3517V36.8528C15.324 37.2746 15.5557 37.6625 15.9276 37.8622C16.2995 38.0631 16.7511 38.0429 17.1039 37.8112L19.6277 36.1567L22.1514 37.8112C22.3405 37.9366 22.5605 37.9993 22.7815 37.9993C22.9675 37.9993 23.1566 37.9536 23.3277 37.8612C23.6986 37.6614 23.9313 37.2736 23.9313 36.8517V30.3485C25.0577 29.237 25.76 27.6951 25.76 25.9896C25.7547 22.6126 23.0057 19.8636 19.6255 19.8636ZM19.6255 22.1578C21.738 22.1578 23.4584 23.8782 23.4584 25.9928C23.4584 28.1063 21.738 29.8267 19.6255 29.8267C17.5109 29.8267 15.7916 28.1063 15.7916 25.9928C15.7916 23.8782 17.512 22.1578 19.6255 22.1578ZM21.6318 34.7265L20.2578 33.8232C19.8742 33.5735 19.3801 33.5735 18.9975 33.8232L17.6225 34.7265V31.7575C18.2537 31.9785 18.9221 32.122 19.6266 32.122C20.3332 32.122 21.0006 31.9775 21.6307 31.7575V34.7265H21.6318Z",
    fill: "url(#paint1_linear_0_289)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.95689 15.6162H13.2551C13.8884 15.6162 14.4027 15.1019 14.4027 14.4686C14.4027 13.8342 13.8884 13.321 13.2551 13.321H7.95689C7.32251 13.321 6.80927 13.8353 6.80927 14.4686C6.80927 15.103 7.32251 15.6162 7.95689 15.6162Z",
    fill: "url(#paint2_linear_0_289)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.95689 9.37766H19.7435C20.3779 9.37766 20.8911 8.86335 20.8911 8.23003C20.8911 7.59671 20.3768 7.0824 19.7435 7.0824H7.95689C7.32251 7.0824 6.80927 7.59671 6.80927 8.23003C6.80927 8.86335 7.32251 9.37766 7.95689 9.37766Z",
    fill: "url(#paint3_linear_0_289)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_289",
    x1: 0.00137412,
    y1: 17.1955,
    x2: 32.0593,
    y2: 17.1955,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0112,
    stopColor: "#FD225C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE7A40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_0_289",
    x1: 13.4947,
    y1: 28.9319,
    x2: 25.7605,
    y2: 28.9319,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0112,
    stopColor: "#FD225C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE7A40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_0_289",
    x1: 6.80959,
    y1: 14.4686,
    x2: 14.403,
    y2: 14.4686,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0112,
    stopColor: "#FD225C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE7A40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_0_289",
    x1: 6.80987,
    y1: 8.23004,
    x2: 20.8916,
    y2: 8.23004,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0112,
    stopColor: "#FD225C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE7A40"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon2);
export default __webpack_public_path__ + "static/media/icon-2.da017ed39c606ef0ca61f7ea3c98f0dd.svg";
export { ForwardRef as ReactComponent };